"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_isequal_1 = __importDefault(require("lodash.isequal"));
var operators_1 = require("../../operators");
var operators_2 = require("rxjs/operators");
var SharedValueFunctionContext = (function () {
    function SharedValueFunctionContext(values) {
        this.values = values;
    }
    SharedValueFunctionContext.prototype.get = function (func) {
        return func(this.values);
    };
    SharedValueFunctionContext.prototype.waitFor = function (func, criteria) {
        return this.valueChanges(func)
            .pipe(operators_1.waitForNext(criteria))
            .toPromise();
    };
    SharedValueFunctionContext.prototype.changes = function (func) {
        return this.valueChanges(func).pipe(operators_2.skip(1));
    };
    SharedValueFunctionContext.prototype.valueChanges = function (func) {
        var _this = this;
        return this.values
            .anyChanges()
            .pipe(operators_2.map(function () { return func(_this.values); }))
            .pipe(operators_2.startWith(func(this.values)), operators_2.distinctUntilChanged(lodash_isequal_1.default));
    };
    return SharedValueFunctionContext;
}());
exports.SharedValueFunctionContext = SharedValueFunctionContext;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2hhcmVkLXZhbHVlLWZ1bmN0aW9uLWNvbnRleHQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvc2hhcmVkLXZhbHVlcy9jb250ZXh0L3NoYXJlZC12YWx1ZS1mdW5jdGlvbi1jb250ZXh0LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7O0FBQUEsa0VBQXFDO0FBR3JDLDZDQUE0QztBQUM1Qyw0Q0FBMEU7QUFFMUU7SUFHSSxvQ0FBWSxNQUFxQztRQUM3QyxJQUFJLENBQUMsTUFBTSxHQUFHLE1BQU0sQ0FBQztJQUN6QixDQUFDO0lBRUQsd0NBQUcsR0FBSCxVQUFPLElBQW9CO1FBQ3ZCLE9BQU8sSUFBSSxDQUFDLElBQUksQ0FBQyxNQUFNLENBQUMsQ0FBQztJQUM3QixDQUFDO0lBRUQsNENBQU8sR0FBUCxVQUFXLElBQW9CLEVBQUUsUUFBMkI7UUFDeEQsT0FBTyxJQUFJLENBQUMsWUFBWSxDQUFDLElBQUksQ0FBQzthQUN6QixJQUFJLENBQUMsdUJBQVcsQ0FBQyxRQUFRLENBQUMsQ0FBQzthQUMzQixTQUFTLEVBQUUsQ0FBQztJQUNyQixDQUFDO0lBRUQsNENBQU8sR0FBUCxVQUFXLElBQW9CO1FBQzNCLE9BQU8sSUFBSSxDQUFDLFlBQVksQ0FBQyxJQUFJLENBQUMsQ0FBQyxJQUFJLENBQUMsZ0JBQUksQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDO0lBQ2pELENBQUM7SUFFTyxpREFBWSxHQUFwQixVQUF3QixJQUFvQjtRQUE1QyxpQkFTQztRQVBHLE9BQU8sSUFBSSxDQUFDLE1BQU07YUFDYixVQUFVLEVBQUU7YUFDWixJQUFJLENBQUMsZUFBRyxDQUFDLGNBQU0sT0FBQSxJQUFJLENBQUMsS0FBSSxDQUFDLE1BQU0sQ0FBQyxFQUFqQixDQUFpQixDQUFDLENBQUM7YUFDbEMsSUFBSSxDQUNELHFCQUFTLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxNQUFNLENBQUMsQ0FBQyxFQUM1QixnQ0FBb0IsQ0FBQyx3QkFBTyxDQUFDLENBQ2hDLENBQUM7SUFDVixDQUFDO0lBQ0wsaUNBQUM7QUFBRCxDQUFDLEFBL0JELElBK0JDO0FBL0JZLGdFQUEwQiJ9